// extracted by mini-css-extract-plugin
export default {"box":"ExtendText_box__og55D","icon":"ExtendText_icon__LvxQ-","text--tn--default":"ExtendText_text--tn--default__qL5qs"};